/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { UiLoadSpinnerIcon16Light } from './UiLoadSpinnerIcon16Light';
import { UiLoadSpinnerIcon16Regular } from './UiLoadSpinnerIcon16Regular';
import { UiLoadSpinnerIcon16Solid } from './UiLoadSpinnerIcon16Solid';
import { UiLoadSpinnerIcon20Light } from './UiLoadSpinnerIcon20Light';
import { UiLoadSpinnerIcon20Regular } from './UiLoadSpinnerIcon20Regular';
import { UiLoadSpinnerIcon20Solid } from './UiLoadSpinnerIcon20Solid';
import { UiLoadSpinnerIcon24Regular } from './UiLoadSpinnerIcon24Regular';
import { UiLoadSpinnerIcon24Solid } from './UiLoadSpinnerIcon24Solid';
import { UiLoadSpinnerIcon32Regular } from './UiLoadSpinnerIcon32Regular';
import { UiLoadSpinnerIcon64Regular } from './UiLoadSpinnerIcon64Regular';
var sizes = {
    16: {
        light: UiLoadSpinnerIcon16Light,
        regular: UiLoadSpinnerIcon16Regular,
        solid: UiLoadSpinnerIcon16Solid,
    },
    20: {
        light: UiLoadSpinnerIcon20Light,
        regular: UiLoadSpinnerIcon20Regular,
        solid: UiLoadSpinnerIcon20Solid,
    },
    24: {
        regular: UiLoadSpinnerIcon24Regular,
        solid: UiLoadSpinnerIcon24Solid,
    },
    32: {
        regular: UiLoadSpinnerIcon32Regular,
    },
    64: {
        regular: UiLoadSpinnerIcon64Regular,
    },
};
export var UiLoadSpinnerIcon = forwardRef('UiLoadSpinnerIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
